import React from 'react'
import { useSelector } from 'react-redux'
import { Route, Switch } from 'react-router'
import NotFoundBackgroundPageContent from 'src/components/NotFoundBackgroundPageContent/NotFoundBackgroundPageContent'
import CardsAppRoute from 'src/navigation/appRoutes/cards.appRoute'
import { Rdrct } from 'src/navigation/Lnk'
import { cardsPhysicalCardsUrl } from 'src/navigation/urls'
import { selectCalculatedBackgroundLocation } from 'src/redux/selectors/router.selectors'

const Cards = (): React.ReactElement => {
  const calculatedBackgroundLocation = useSelector(
    selectCalculatedBackgroundLocation,
  )

  return (
    <Switch location={calculatedBackgroundLocation}>
      {CardsAppRoute.subRoutes.map((route, i) => (
        <Route key={i} {...route.routeProps}>
          {route.component}
        </Route>
      ))}
      <Route {...CardsAppRoute.routeProps} exact>
        <Rdrct to={cardsPhysicalCardsUrl()} />{' '}
        {/* TODO: route to virtual cards by default */}
      </Route>
      <Route path={'/'}>
        <NotFoundBackgroundPageContent />
      </Route>
    </Switch>
  )
}

export default Cards
